// ESM wrapper for zustand - re-exports and sets up globals for sharing
// Note: zustand v3 only exports 'create' as default
import create from 'zustand';

// Re-export create as both default and named export
export { create };
export default create;

// Also export createStore (it's the internal function used by create)
// This is needed for context-based stores
export function createStore(createState) {
  let state;
  const listeners = new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(setState, getState, api);
  return api;
}

// Set window global for shared instance
if (typeof window !== 'undefined') {
  window.__SHARED_ZUSTAND__ = {
    create,
    createStore,
  };
}
